export const ADMIN_TOKEN_KEY = "fm_admin_token";
export const APP_NAME = "Business Studio Suite";
export const CUSTOMER_TOKEN_KEY = "fm_customer_token";

export const DOC_LABELS = {
  angebot: "Angebot",
  rechnung: "Rechnung",
  anzahlungsrechnung: "Anzahlungsrechnung",
  schlussrechnung: "Schlussrechnung",
  gutschrift: "Gutschrift",
  storno: "Stornorechnung",
  auftragsbestaetigung: "Auftragsbestätigung",
  lieferschein: "Lieferschein",
};
export const INVOICE_TYPES = ["rechnung", "anzahlungsrechnung", "schlussrechnung", "gutschrift", "storno"];

// Die interne Dokumentart bleibt "angebot". Nur die sichtbare Bezeichnung ist je Organisation
// frei wählbar; für Schweizer Mandanten gilt ohne eigene Auswahl automatisch „Offerte“.
export const offerLabel = (company = {}) => {
  const custom = String(company?.offer_label || "").trim().replace(/\s+/g, " ");
  if (custom) return custom.slice(0, 50);
  const isSwiss = company?.main_country === "CH" || String(company?.land || "").trim().toLowerCase() === "schweiz";
  return isSwiss ? "Offerte" : "Angebot";
};

export const offerLabelPlural = (company = {}) => {
  const custom = String(company?.offer_label || "").trim().replace(/\s+/g, " ");
  if (custom) return custom;
  return offerLabel(company) === "Offerte" ? "Offerten" : "Angebote";
};

export const docLabel = (t, company = {}) => (
  (t || "angebot") === "angebot" ? offerLabel(company) : (DOC_LABELS[t || "angebot"] || "Dokument")
);

export const STATUS_META = {
  draft: { label: "Entwurf", color: "#9CA3AF" },
  reviewed: { label: "Geprüft", color: "#64748B" },
  approved: { label: "Freigegeben", color: "#0F766E" },
  issued: { label: "Festgeschrieben", color: "#7C3AED" },
  sent: { label: "Versendet", color: "#3B82F6" },
  opened: { label: "Geöffnet", color: "#8B5CF6" },
  accepted: { label: "Angenommen", color: "#10B981" },
  declined: { label: "Abgelehnt", color: "#EF4444" },
  invoiced: { label: "In Rechnung", color: "#F59E0B" },
  partially_paid: { label: "Teilbezahlt", color: "#D97706" },
  overdue: { label: "Überfällig", color: "#DC2626" },
  cancelled: { label: "Storniert", color: "#6B7280" },
  paid: { label: "Bezahlt", color: "#059669" },
};
export const STATUS_ORDER = ["draft", "reviewed", "approved", "issued", "sent", "opened", "accepted", "declined", "invoiced", "partially_paid", "overdue", "paid", "cancelled"];

// Kunden-Status / Segmentierung (CRM)
export const CUSTOMER_STATUS_META = {
  lead: { label: "Lead", color: "#3B82F6" },
  aktiv: { label: "Aktiv", color: "#10B981" },
  inaktiv: { label: "Inaktiv", color: "#9CA3AF" },
  vip: { label: "VIP", color: "#B8924A" },
};
export const CUSTOMER_STATUSES = ["lead", "aktiv", "inaktiv", "vip"];
export const DEMO_ORG_ID = "demo-showcase-org";

// CRM Deal-Stages (muss mit Backend CRM_STAGES übereinstimmen)
export const CRM_STAGE_META = {
  neu: { label: "Neu", color: "#3B82F6" },
  angebot: { label: "Angebot", color: "#8B5CF6" },
  verhandlung: { label: "Verhandlung", color: "#F59E0B" },
  gewonnen: { label: "Gewonnen", color: "#10B981" },
  verloren: { label: "Verloren", color: "#EF4444" },
};
export const CRM_STAGES = ["neu", "angebot", "verhandlung", "gewonnen", "verloren"];

// E-Mail-Vorlagen für den Schnellversand aus dem Kundenprofil.
// Platzhalter: {name} = Ansprechpartner, {firma} = Kundenfirma
export const EMAIL_TEMPLATES = [
  {
    id: "followup",
    name: "Angebot nachfassen",
    subject: "Ihr Angebot – kurze Rückfrage",
    body: "ich wollte mich kurz erkundigen, ob Sie unser Angebot bereits prüfen konnten.\n\nGerne beantworte ich offene Fragen und passe das Angebot bei Bedarf an Ihre Wünsche an.\n\nIch freue mich auf Ihre Rückmeldung.",
  },
  {
    id: "reminder",
    name: "Zahlungserinnerung",
    subject: "Freundliche Zahlungserinnerung",
    body: "sicher ist es Ihrer Aufmerksamkeit entgangen – unsere Rechnung ist noch offen.\n\nWir möchten Sie freundlich bitten, den offenen Betrag in den nächsten Tagen zu begleichen. Sollten Sie die Zahlung bereits veranlasst haben, betrachten Sie diese Nachricht als gegenstandslos.\n\nVielen Dank für Ihr Verständnis.",
  },
  {
    id: "appointment",
    name: "Terminvorschlag",
    subject: "Terminvorschlag für ein kurzes Gespräch",
    body: "gerne würde ich die nächsten Schritte in einem kurzen Gespräch mit Ihnen besprechen.\n\nPasst Ihnen einer der folgenden Termine?\n\n– \n– \n\nAlternativ nennen Sie mir gerne einen Zeitpunkt, der Ihnen besser passt.",
  },
  {
    id: "thankyou",
    name: "Dankeschön",
    subject: "Vielen Dank für Ihr Vertrauen",
    body: "vielen Dank für die angenehme Zusammenarbeit und Ihr Vertrauen.\n\nSollten Sie weitere Unterstützung benötigen, bin ich jederzeit gerne für Sie da.",
  },
];

export const COLOR_FIELDS = [
  { key: "color_primary", label: "Primärfarbe", cssVar: "--brand-primary" },
  { key: "color_primary_dark", label: "Primär (dunkel)", cssVar: "--brand-primary-dark" },
  { key: "color_bg", label: "Hintergrund", cssVar: "--brand-bg" },
  { key: "color_border", label: "Rahmen", cssVar: "--brand-border" },
  { key: "color_ink", label: "Textfarbe", cssVar: "--brand-ink" },
];
